module.exports = __webpack_public_path__ + "static/media/story-28.4c0ce8c4.jpg";